import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button, Paper, Stack, CircularProgress, Alert } from '@mui/material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useSessionReport } from '../workouts/session-view/hooks/useSessionReport';
import { useResources } from '@platform/core/src/context/ResourceContext';
import WorkoutSessionReportModal from '../reports/WorkoutSessionReportModal';

const WorkoutSessionReportMessage = ({ sessionId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { report, isGenerating, error } = useSessionReport(sessionId, 'COMPLETED');
  const { getResourceById } = useResources();
  const session = getResourceById(sessionId);
  const isReady = report && report.status === 'complete';

  return (
    <>
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          maxWidth: '100%',
          bgcolor: isReady ? 'rgba(76, 175, 80, 0.08)' : 'background.paper',
          borderColor: isReady ? 'success.main' : 'divider'
        }}
      >
        <Stack spacing={2}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            {isReady ? (
              <CheckCircleIcon color="success" />
            ) : (
              <CircularProgress size={24} />
            )}
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {isReady ? 'Smart Assessment Ready' : 'Analyzing Workout'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {isReady
                  ? 'Your AI assistant has finished analyzing your performance.'
                  : 'Generating your Smart Assessment report now...'}
              </Typography>
            </Box>
          </Box>

          {error && !isGenerating && !isReady && (
            <Alert severity="error">
              Unable to generate report at this time.
            </Alert>
          )}

          {isReady && (
            <Button
              variant="contained"
              color="primary"
              startIcon={<AssessmentIcon />}
              onClick={() => setIsModalOpen(true)}
              fullWidth
            >
              View Report
            </Button>
          )}
        </Stack>
      </Paper>

      {isReady && (
        <WorkoutSessionReportModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          session={session}
        />
      )}
    </>
  );
};

WorkoutSessionReportMessage.propTypes = {
  sessionId: PropTypes.string.isRequired,
};

export default WorkoutSessionReportMessage;